import ascending from "./ascending.js";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/order/descending.js
// module id = 921
// module chunks = 0